
export const forFutureRelease = process.env.REACT_APP_FUTURE_CODE === "true"
? process.env.REACT_APP_FUTURE_CODE
: false;
